<template>
  <section id="imprint" class="imprint">
    <div class="container">
      <h2>{{ $t('imprint.title') }}</h2>
      <div class="legal-grid">
        <div class="legal-item">
          <h3>{{ $t('imprint.legalName') }}</h3>
          <p>
            {{ $t('imprint.address') }}<br>
            {{ $t('imprint.commercialRegister') }}<br>
            <strong>{{ $t('imprint.representedBy') }}:</strong> Marc Matt
          </p>
        </div>
        
        <div class="legal-item">
          <h3>{{ $t('imprint.contact') }}</h3>
          <p>
            {{ $t('imprint.phone') }}: (040) 33460089<br>
            {{ $t('imprint.email') }}: kontakt@data-do.de
          </p>
          <h3 class="mt-20">{{ $t('imprint.responsible') }}</h3>
          <p>Marc Matt</p>
        </div>
        
        <div class="legal-item">
          <h3>{{ $t('imprint.vatIdTitle') }}</h3>
          <p>{{ $t('imprint.vatId') }}</p>
          <h3 class="mt-20">{{ $t('imprint.dispute') }}</h3>
          <p>{{ $t('imprint.disputeText') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.imprint {
  padding: 60px 20px;
  background-color: var(--gray-light);
  border-top: 1px solid #eee;
}

.container {
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  margin-bottom: 40px;
  text-align: center;
}

.legal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.legal-item h3 {
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: var(--primary-color);
}

.mt-20 {
  margin-top: 20px;
}

.legal-item p {
  line-height: 1.6;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .imprint {
    padding: 40px 15px;
  }
  .legal-grid {
    grid-template-columns: 1fr;
  }
}
</style>
